module.exports = __webpack_public_path__ + "img/box_pro_seven_3.d717ce34.jpg";